const scrollToTarget = (linkSelector) => {
	const link = document.querySelector(linkSelector);

	if (!link) return;

	const headerHeight = 200;

	link.addEventListener('click', (event) => {
		event.preventDefault();

		const targetId = link.getAttribute('href').slice(1);
		const targetElement = document.getElementById(targetId);

		if (targetElement) {
			const targetPosition = targetElement.getBoundingClientRect().top + window.scrollY;
			const offsetPosition = targetPosition - headerHeight;

			window.scrollTo({
				top: offsetPosition,
				behavior: 'smooth',
			});

			// Find and activate the corresponding tab
			const tabs = document.querySelectorAll('.nav-link');
			const panes = document.querySelectorAll('.tab-pane');

			tabs.forEach((tab) => tab.classList.remove('active'));
			panes.forEach((pane) => pane.classList.remove('active'));

			const targetId = targetElement.getAttribute('href').slice(1);
			const paneToActivate = document.getElementById(targetId);

			if (targetElement && paneToActivate) {
				targetElement.classList.add('active');
				paneToActivate.classList.add('active');
			}
		}
	});
};

document.addEventListener('DOMContentLoaded', () => {
	scrollToTarget(".description-anchor a[href^='#']");
	scrollToTarget(".product-link--reviews");
});  